export abstract class StrategyBuilder<Type> {
    abstract build(details): Type;
}

